import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import { getIndividualReportPart } from "../ReportElementHelper";
import SimpleAccordionContent from "../../common/SimpleAccordionContent";

class PeopleAtWorkReport extends Component {
  state = {
    individualTables: [],
    savedResultID: "",
    internalID: "",
  };

  componentWillReceiveProps(nextProps) {
    const { internalID, savedResultID } = nextProps.additionalData;
    if (
      this.state.internalID !== internalID ||
      this.state.savedResultID !== savedResultID
    ) {
      this.setState({ internalID, savedResultID });
      this.loadData(nextProps);
    }
  }

  handleClick = () => {
    if (this.state.activeIndex === 0) {
      this.setState({ activeIndex: -1 });
    } else {
      this.setState({ activeIndex: 0 });
    }
  };

  loadData = (props) => {
    const individualTables = [];
    let recCount = 0;
    if (props.reportData !== undefined) {
      const peopleAtWorks = _.get(
        props.reportData,
        "personReport.compReportResponse[0].individual[0].peopleAtWorks[0].peopleAtWork"
      );
      if (peopleAtWorks && peopleAtWorks.length > 0) {
        _.forEach(peopleAtWorks, (record, index) => {
          const rows = getIndividualReportPart(record, props);
          if (rows.length > 0) {
            individualTables.push(
              <Table.Row key={`paw_individual_${index}`}>
                <Table.Cell>
                  <Table>
                    <Table.Body>
                      <Table.Row>
                        <Table.HeaderCell
                          colSpan={6}
                          className="report-sub-section-header"
                        >
                          Individual
                        </Table.HeaderCell>
                      </Table.Row>
                      {rows}
                    </Table.Body>
                  </Table>
                </Table.Cell>
              </Table.Row>
            );
          }
        });
        recCount = individualTables.length;
      } else {
        individualTables.push(
          <Table.Row key={`no_recs_row`}>
            <Table.Cell colSpan={2}>No Records found</Table.Cell>
          </Table.Row>
        );
      }
    } else {
      individualTables.push(
        <Table.Row key={`no_recs_row`}>
          <Table.Cell colSpan={2}>No Records found</Table.Cell>
        </Table.Row>
      );
    }
    this.setState({ individualTables });
    props.updateItemCountBySection(props.sectionName, recCount);
  };

  render() {
    return (
      <SimpleAccordionContent
        {...this.props}
        name={"People At Work"}
        rows={this.state.individualTables}
      />
    );
  }
}

export default PeopleAtWorkReport;



// WEBPACK FOOTER //
// ./src/components/reports/Platinum/PeopleAtWorkReport.js